import { AfterViewInit, Component, ElementRef, ViewChild, Input } from '@angular/core';
import { DashboardService } from '@app/_services/dashboard.service';
import { first } from 'rxjs/operators';

declare var google: any;

@Component({
  selector: 'app-pie-chart-top10',
  template: `<div #pieChart style="width: 100%; height: 100%;" ></div>`
})
export class PieChartTop10Component implements AfterViewInit {

  @ViewChild('pieChart') pieChart: ElementRef

  yr: any;

  @Input() set count(count: number) {
    this.yr = count;
    const chart = new google.visualization.PieChart(this.pieChart.nativeElement);
    const options = {
      // pieSliceText: 'value',
      legend: { position: 'top' }
    };
    var getTopTenEmployerResponse7: any;
    this.dashboardService.getTopTenEmployer(this.yr)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getTopTenEmployer response---", data)
          getTopTenEmployerResponse7 = data.respData;


          var data1 = [];
          var Header = ['Element', 'Density'];
          data1.push(Header);
          for (var i = 0; i < data.respData.length; i++) {
            var temp = [];
            temp.push(data.respData[i].companyNm);
            temp.push(data.respData[i].totalamt);

            data1.push(temp);
          }
          var chartdata = new google.visualization.arrayToDataTable(data1);
          chart.draw(chartdata, options);
        },
        error => {
          console.log(error)
        }
      )

  }

  constructor(private dashboardService: DashboardService) { this.yr }

  chartdata: any;
  // getTopTenEmployerResponse: any;
  result = [];
  currentyear = (new Date()).getFullYear();

  drawChart = () => {
    var getTopTenEmployerResponse8: any;
    this.dashboardService.getTopTenEmployer(this.currentyear)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getTopTenEmployer response---", data)
          getTopTenEmployerResponse8 = data.respData;
          var data1 = [];
          var Header = ['Element', 'Density'];
          data1.push(Header);
          for (var i = 0; i < data.respData.length; i++) {
            var temp = [];
            temp.push(data.respData[i].companyNm);
            temp.push(data.respData[i].totalamt);

            data1.push(temp);
          }
          var chartdata = new google.visualization.arrayToDataTable(data1);
          chart.draw(chartdata, options);
        },
        error => {
          console.log(error)
        }
      )


    const options = {
      legend: { position: 'top' },
      //pieSliceText: 'value',
    };

    const chart = new google.visualization.PieChart(this.pieChart.nativeElement);
  }

  ngAfterViewInit() {
    google.charts.load('current', { 'packages': ['corechart'] });
    google.charts.setOnLoadCallback(this.drawChart);
  }
}